export default "__VITE_ASSET__nKMc4ITl__"